<template>
    <div class="px-4 py-4 sm:px-10 sm:mt-4">
        <div class="rounded-md bg-blue-50 p-4 mb-4" v-if="forgotForm.errors.general">
            <div class="flex">
                <div class="flex-shrink-0">
                    <XCircleIcon class="h-5 w-5 text-blue-400" aria-hidden="true" />
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-blue-800">{{forgotForm.errors.general}}</h3>
                    <div class="mt-2 text-sm text-blue-700" v-html="forgotForm.errors.detail">
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <form id="reg" action="#" method="POST" class="" @submit.prevent="forgotPassword()">
                <div class="grid grid-cols-1 gap-y-1 gap-x-1 sm:grid-cols-6">
                    <div class="sm:col-span-6">
                        <label for="email" class="block text-sm font-medium text-gray-700">{{ translate('body:email') }}</label>
                        <div class="relative mt-1">
                            <input v-model="forgotForm.email" id="email" name="email" type="text" :placeholder="translate('body:emailPlaceHolder')" required="" class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="forgotForm.errors.email">
                                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
                            </div>
                        </div>
                        <p class="mt-2 text-sm text-red-600" id="email-error">{{forgotForm.errors.email}}</p>
                    </div>

                    <div class="sm:col-span-6">
                        <button v-if="!submitting" type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            {{ translate('body:resetButton') }}
                        </button>
                        <button v-if="submitting" type="button" class="w-full flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none">
                            <Cog6ToothIcon class="animate-spin-slow h-5 w-5 mr-3" />
                            {{ translate('body:resetButtonWait') }}
                        </button>


                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
        <div class="grid grid-cols-2">
            <div class="text-xs leading-5 text-gray-500 inline-flex">
                <UserIcon class="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                <Link :href="route('auth_login_display_localized')" class="font-medium text-gray-900 hover:underline">{{ translate('footer:login') }}</Link>
            </div>
            <div class="text-xs leading-5 text-gray-500 inline-flex">
                <UserPlusIcon class="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                <Link :href="route('auth_register_display_localized')" class="font-medium text-gray-900 hover:underline">{{ translate('footer:register') }}</Link>
            </div>
        </div>
    </div>
</template>
<script>

import {useForm, usePage, Link} from "@inertiajs/inertia-vue3";
import { ExclamationCircleIcon, ExclamationTriangleIcon, UserPlusIcon, UserIcon } from '@heroicons/vue/24/solid'
import translate from "../../../lang";
import { XCircleIcon } from '@heroicons/vue/20/solid'
import {ref} from "vue";
import { Cog6ToothIcon } from '@heroicons/vue/24/solid';


export default {
    components: {
        Link,
        ExclamationCircleIcon,
        ExclamationTriangleIcon,
        UserPlusIcon,
        UserIcon,
        XCircleIcon,
        Cog6ToothIcon
    },
    props: {
        email: String
    },

    setup(props) {

        const submitting = ref(false);

        const forgotForm = useForm({
            email: props.email,
        })

        function forgotPassword() {
            submitting.value = true;
            forgotForm.post(route('auth_forgot_password_submit_localized'), {
                onFinish: () => {
                    submitting.value = false;
                }
            });
        }

        return {
            forgotForm,
            translate: translate('auth.forgot'),
            submitting,
            forgotPassword
        }
    }
}

</script>
